import React from 'react';
import styled from 'styled-components';
import { FormattedMessage } from 'react-intl';
import colors from '../../../styled/colors';
import { TriangleIcon, CircleIcon, WaveIcon } from '../iconsSVG/icons';
import Action from '../components/Action';
import useGetActionsContent from '../data/useGetActionsContent';
import mediaQueries from '../../../utils/mediaQueries';

const Section = styled.section`
  background: ${colors.white};
  padding: 40px 24px 20px;
  @media ${mediaQueries.mdUp} {
    padding: 68px 24px 20px;
  }
  @media ${mediaQueries.lgPlusUp} {
    padding: 74px 42px 20px;
  }
  @media ${mediaQueries.xlPlusUp} {
    padding: 84px 130px 20px;
  }
  @media ${mediaQueries.xxlUp} {
    padding-left: 185px;
    padding-right: 185px;
  }
`;
const TitleContainer = styled.div`
  display: flex;
  justify-content: center;
`;
const Title = styled.h2`
  color: ${colors.black3E};
  font-size: 20px;
  font-weight: normal;
  max-width: 323px;
  text-align: center;
  position: relative;
  z-index: 1;
  @media ${mediaQueries.mdUp} {
    font-size: 24px;
    max-width: 470px;
    strong {
      font-size: 29px;
    }
  }
  @media ${mediaQueries.lgPlusUp} {
    font-size: 28px;
    max-width: max-content;
    strong {
      font-size: 31px;
    }
  }
  @media ${mediaQueries.xlPlusUp} {
    font-size: 32px;
    strong {
      font-size: 36px;
    }
  }
  &:before {
    content: '';
    background: ${colors.secondaryDark};
    border-radius: 50%;
    height: 50px;
    width: 50px;
    opacity: 0.5;
    position: absolute;
    top: -14px;
    right: 46px;
    z-index: -1;
    @media ${mediaQueries.mdUp} {
      width: 65px;
      height: 65px;
      top: -38px;
      right: calc(50% - 238px);
    }
    @media ${mediaQueries.lgPlusUp} {
      width: 79px;
      height: 79px;
      top: -18px;
      right: calc(50% - 245px);
    }
    @media ${mediaQueries.xlPlusUp} {
      top: -22px;
      right: calc(50% - 269px);
    }
  }
  &:after {
    content: '';
    border: 1px solid ${colors.black3E};
    border-radius: 50%;
    height: 5px;
    width: 5px;
    position: absolute;
    z-index: -1;
    top: -16px;
    left: 90px;
    @media ${mediaQueries.mdUp} {
      width: 9px;
      height: 9px;
      top: -20px;
      left: 130px;
    }
    @media ${mediaQueries.lgPlusUp} {
      left: 165px;
      top: -16px;
    }
    @media ${mediaQueries.xlPlusUp} {
      left:196px;
    }
  }
  svg {
    position: absolute;
    z-index: -1;
  }
  .triangle {
    left: 10px;
    bottom: 10px;
    @media ${mediaQueries.mdUp} {
      width: 29px;
      height: 29px;
      stroke-width: 0.5px;
      left: -18px;
      bottom: -20px;
    }
    @media ${mediaQueries.lgPlusUp} {
      left: 79px;
      bottom: -30px;
    }
  }
  .circle {
    top: -10px;
    right: 47%;
    @media ${mediaQueries.mdUp} {
      width: 12px;
      height: 12px;
      stroke-width: 0.5px;
      top: -33px;
    }
    @media ${mediaQueries.lgPlusUp} {
      right: 70%;
      top: -2px;
    }
  }
  .wave {
    bottom: 0px;
    right: 18px;
    @media ${mediaQueries.mdUp} {
      width: 45px;
      height: 23px;
      bottom: -14px;
    }
    @media ${mediaQueries.lgPlusUp} {
      bottom: -46px;
      width: 73px;
      height: 41px;
      right: 88px;
    }
    @media ${mediaQueries.xlPlsUp} {
      bottom: 44px;
      right: 58px;
    }
  }
`;
const Content = styled.div`
  margin-top: 22px;
  @media ${mediaQueries.mdUp} {
    margin-top: 80px;
  }
  @media ${mediaQueries.lgPlusUp} {
    margin-top: 96px;
  }
  @media ${mediaQueries.xlPlusUp} {
    margin-top: 75px;
  }
  @media ${mediaQueries.xxlUp} {
    margin-left: auto;
    margin-right: auto;
    max-width: 1430px;
  }
`;

const Actions = () => {
  const actionsContent = useGetActionsContent();
  return (
    <Section>
      <TitleContainer>
        <Title>
          <FormattedMessage
            id="landing.instagram.actions.title"
            defaultMessage="With Social Piper, <s>the best tool for Instagram</s>, you can:"
            values={{
              s: (...chunks) => <strong>{chunks}</strong>,
            }}
          />
          <TriangleIcon className="triangle" />
          <CircleIcon className="circle" />
          <WaveIcon className="wave" />
        </Title>
      </TitleContainer>
      <Content>
        {actionsContent.map((action) => (
          <Action action={action} key={action.key} />
        ))}
      </Content>
    </Section>
  );
};

export default Actions;
